import React from 'react';
import '../template-file-css/document-file-template.css';


export const CS_Disclosure = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='CS_Disclosure' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <center>
                        <b>
                            <u>
                                DISCLOSURE
                            </u>
                        </b>
                    </center>
                </p>


                <p className='w-750'>
                    Individuals with employment challenges can decide whether to share specific information and challenges with
                    employers, or can decide whether to receive job leads, instead of the Employment Coordinator searching on
                    your behalf. Employment supports could aid in helping to eliminate or decrease challenges and barriers.
                    Additionally, employers may be able to offer accommodations for specific needs of an employee.

                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Client Name:</span>
                    <input type='text' id='txtClientName_1' name='txtClientName_1' className='add-only w-375' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Do you foresee any disadvantage of disclosing to an employer?</span>

                    <input type='radio' id='rbDisclosingToAnEmployer_Yes' name='rbDisclosingToAnEmployer' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDisclosingToAnEmployer_No' name='rbDisclosingToAnEmployer' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If no, how do you feel disclosing specific information to an employer can benefit you?</span>

                    <textarea id='txtDisclosingToAnEmployerIfNo' name='txtDisclosingToAnEmployerIfNo' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are you open to Core Solutio speaking to an employer on your behalf and disclosing your disability for work
                        related purposes only?</span>

                    <input type='radio' id='rbRelatedPurposesOnly_Yes' name='rbRelatedPurposesOnly' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbRelatedPurposesOnly_No' name='rbRelatedPurposesOnly' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <b>(circle or highlight an option below)</b>
                    <br />

                    <input type='radio' id='rbHighlightOption_Self' name='rbHighlightOption' className='add-only' value='Self' /> Self &nbsp;
                    <input type='radio' id='rbHighlightOption_Guardian' name='rbHighlightOption' className='add-only' value='Guardian' /> Guardian &nbsp;
                    <input type='radio' id='rbHighlightOption_Other' name='rbHighlightOption' className='add-only' value='Other' /> Other
                </p>


                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Employment Coordinator Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Client or Guardian Name:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtEmploymentCoordinatorName' name='txtEmploymentCoordinatorName' type='text' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtClientGuardianName' name='txtClientGuardianName' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Date:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtEmploymentCoordinatorNamedate' name='txtEmploymentCoordinatorNamedate' type='date' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtClientGuardianNamedate' name='txtClientGuardianNamedate' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Employment Coordinator Signature  </td>
                        <td className='small w-375'> Signature</td>
                    </tr>
                </table>

            </div>
        </form>

    )
}